import styled from 'styled-components'

import { CardsListUnstyled } from 'Components/CardsList/unstyled'

export const CardsList = styled(CardsListUnstyled)`
  position: relative;
  width: auto;
  overflow: hidden;
  margin: 28px -13px 0 -13px;
  pading: 14px;

  .col-xs-3 {
    padding: 0 13px 13px 15px;
  }

  &.as-list {
    margin-bottom: 20px;

    .col-xs-3 {
      width: 100%;
      padding: 0 13px 3px 15px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/CardsList/index.js